__turbopack_context__.v({
  "ouro-logo": "OuroLogo-module-scss-module__AwzeUW__ouro-logo",
});
